import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import I18n from 'i18n-js';
import { Menu, Dropdown, Icon } from 'grab-ui';
import { getCityStorage } from 'helper/storage';
import { selectCityAction } from 'actions/app-actions';

import { trackClick, event, cat, custom } from 'common/utils/instrumentation';

import css from './city-select.less';

const MenuItem = Menu.Item;

class CitySelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownVisible: false,
      city: getCityStorage().city || '',
    };
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutsideDropDown);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutsideDropDown);
  }

  handleClickOutsideDropDown = event => {
    const { dropdownVisible } = this.state;
    if (
      dropdownVisible &&
      this.dropdownRef &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ dropdownVisible: false });
    }
  };

  onClickShowDropdown = () => {
    const { companyID } = this.props;
    trackClick(event.HOMEPAGE_CLICKS, cat.GE_HOMEPAGE, 'CITY_SELECTION', {
      [custom.COMPANY_ID]: companyID,
    });

    const { dropdownVisible } = this.state;
    this.setState({ dropdownVisible: !dropdownVisible });
  };

  onSelectCity = cityName => () => {
    const { cities, selectCity } = this.props;
    const city = cities.find(c => c.name === cityName);
    this.setState({ dropdownVisible: false, city: cityName });
    selectCity(city);
  };

  renderDropdown = () => {
    const { city } = this.state;
    const { cities } = this.props;
    return (
      <div ref={this.dropdownRef}>
        <Menu>
          {cities.map(c => (
            <MenuItem
              key={`${c.name}-${c.code}`}
              onClick={this.onSelectCity(c.name)}
              className={c.name === city ? css.selectedCity : ''}
            >
              {c.name}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  };

  render() {
    const { city, dropdownVisible } = this.state;

    /* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
    return (
      <div className={css.citySelect}>
        <h4
          onClick={this.onClickShowDropdown}
          role="button"
          tabIndex={-123}
          onKeyPress={null}
        >
          {I18n.t('v2.homepage.deliverIn', { city })}
        </h4>
        <Dropdown
          overlay={this.renderDropdown()}
          trigger={['click']}
          placement="bottomCenter"
          overlayClassName={css.dropdown}
          visible={dropdownVisible}
        >
          <Icon
            type={dropdownVisible ? 'up' : 'down'}
            onClick={this.onClickShowDropdown}
          />
        </Dropdown>
      </div>
    );
    /* eslint-enable */
  }
}

CitySelect.propTypes = {
  cities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectCity: PropTypes.func.isRequired,
  companyID: PropTypes.number.isRequired,
};

const mapDispatchToProps = {
  selectCity: selectCityAction,
};

export default connect(null, mapDispatchToProps)(CitySelect);
